import PropTypes from 'prop-types'
import { InputField, LoaderButton } from 'components/molecules'
import { Form, Formik } from 'formik'
import React from 'react'
import * as Yup from 'yup'
import { PaymentMethodSelectSearchField } from 'domains/payment-method/components'

const propTypes = {
  order: PropTypes.shape({
    id     : PropTypes.number.isRequired,
    number : PropTypes.string.isRequired,
    total  : PropTypes.number.isRequired
  }),
  onSubmit: PropTypes.func.isRequired
}

const paymentValidationSchema = Yup.object().shape({
  order: Yup.object().shape({
    id     : Yup.string().required('Required'),
    number : Yup.string(),
    amount : Yup.string()
  }),
  payment_method: Yup.object().required('Please select a bank_transfer Payment Method.')
})

const CustomerOrderPaymentForm = ({ order, onSubmit }) => (
  <Formik
    enableReinitialize
    validationSchema={ paymentValidationSchema }
    initialValues={{
      order: {
        id     : order?.id || -1,
        number : order?.number || -1,
        amount : order?.total || -1
      },
      payment_method: ''
    }}
    onSubmit={ (values, formikBag) => onSubmit(values, formikBag) }
  >
    {
      (formikBag) => (
        <Form>
          <div className='pb-3'>
            <div className="small text-uppercase text-primary font-weight-bolder">Customer Order Payment Create Form</div>
            <small>A BankTransfer will be created with this Payment.</small>
          </div>
          <InputField
            name='order.id'
            label='Order ID'
            type='number'
            formText='Autofilled based on the current Order ID'
            disabled // disabled since we are passing order object into here
          />
          <InputField
            name='order.number'
            label='Order Number'
            type='text'
            formText='Autofilled based on the current Order Number'
            disabled // disabled since we are passing order object into here
          />
          <InputField
            name='order.amount'
            label='Amount Due'
            type='number'
            formText='Autofilled based on the current Order Grand Total'
            disabled // disabled since we are passing order object into here
          />
          <PaymentMethodSelectSearchField
            name='payment_method'
            label='Payment Method'
            filters={{ category: 'bank_transfer' }}
            formText='Only Payment Methods with category bank_transfer are shown and allowed.'
          />

          <div className='text-right'>
            <LoaderButton
              color='primary'
              type='submit'
              onSubmit={ formikBag.submitForm }
              disabled={ formikBag.isSubmitting }
              isLoading={ formikBag.isSubmitting }
              text='Create Payment'
            />
          </div>
        </Form>
      )
    }

  </Formik>
)

CustomerOrderPaymentForm.propTypes = propTypes

export default CustomerOrderPaymentForm